import { Link } from "react-router-dom";
import buyImage from "../assets/buy_image.jpeg";
import sellImage from "../assets/sell_image.png";
import tradeImage from "../assets/trade_image.jpeg";
import watchServiceImage from "../assets/watch_service_image.png";

const SERVICES = [
  {
    id: "buy",
    label: "Buy",
    icon: "buy",
    headline: "Buy a Watch",
    tagline:
      "Luxury watches are as much about resonating with your personal style as they are about keeping time. We'll help you find your perfect piece, all while keeping the process simple, transparent, and personal.",
    image: buyImage,
    steps: [
      {
        title: "Explore Our Curated Collection",
        description: (
          <>
            Browse our{" "}
            <Link to="/watches" style={{ color: "black" }}>
              catalogue
            </Link>{" "}
            and find your perfect piece.
          </>
        ),
      },
      {
        title: "Connect with Our Team",
        description:
          "Reach out to our dedicated team via WhatsApp for personalized assistance.",
      },
      {
        title: "Own Your Legacy",
        description:
          "Secure your selection and enjoy the timeless elegance of your luxury timepiece.",
      },
    ],
    focalPoint: "50% 45%",
  },
  {
    id: "sell",
    label: "Sell",
    icon: "sell",
    headline: "Sell Your Watch",
    tagline:
      "When it comes time to sell your timepiece, we ensure a professional and transparent experience. Your satisfaction is our priority, and so we work to give you the best value we can.",
    image: sellImage,
    steps: [
      {
        title: "Schedule Your Personalized Appointment",
        description:
          "Arrange a personalized session organized around your comfort and convenience.",
      },
      {
        title: "Present Your Timepiece",
        description:
          "Prepare your watch alongside its original box, warranty card, and accessories.",
      },
      {
        title: "Receive a Professional Assessment",
        description:
          "Our specialists will provide a meticulous evaluation by validating its authenticity, assessing its condition, and considering the market demand.",
      },
      {
        title: "Finalize Payment",
        description:
          "Coordinate the payment method with our team. We work with each client on an individual level to reach the best solution for you.",
      },
    ],
    focalPoint: "50% 35%",
  },
  {
    id: "trade",
    label: "Trade-In",
    icon: "trade",
    headline: "Trade-In Your Watch",
    tagline: (
      <>
        Sometimes, the true luxury lies not just in owning a watch, but in
        evolving your connection. At Legacy Timepieces, we strive to deliver
        high-quality service that centers communication and flexibility. <br />{" "}
        <br /> Our store offers an extensive collection of luxury watches and a
        highly experienced team of experts, working together with you to create
        the best trade-in experience we can.
      </>
    ),
    image: tradeImage,
    steps: [
      {
        title: "Present Your Watch for Evaluation",
        description:
          "Bring your timepiece, complete with its box and papers, for an accurate appraisal.",
      },
      {
        title: "Discover Our Curated Selection",
        description:
          "Our catalog of luxury watches, or connect with us for tailored recommendations.",
      },
      {
        title: "Complete Your Exchange",
        description:
          "Our team will work directly with you to ensure you receive the best value for your exchange.",
      },
    ],
    focalPoint: "50% 50%",
  },
  {
    id: "watch-service",
    label: "Watch Service",
    icon: "consignment",
    headline: "Service & Maintenance",
    tagline:
      "At Legacy Timepieces, our services don't end after a watch changes hands. Watches are complex mechanical machines, and all need proper maintenance and care to ensure they last for generations. No matter if you need routine maintenance or emergency repairs, our skilled in-house technicians are ready to offer our services.",
    image: watchServiceImage,
    steps: [
      {
        title: "Bring Your Watch in For Inspection",
        description:
          "Bring your watch into our store for our technician to inspect.",
      },
      {
        title: "Discuss The Problem",
        description:
          "Once your watch has been inspected by our experts, we will explain the issues, necessary repairs, and the associated costs.",
      },
      {
        title: "Authorize Transaction",
        description:
          "After agreeing on the service items and their costs, your watch will be entered into our service queue.",
      },
      {
        title: "Receive Status Updates",
        description:
          "We will update you of your timepiece's status through your preferred contact method. Most service is completed within 3-7 days.",
      },
    ],
    focalPoint: "50% 45%",
  },
];

export default SERVICES;
